import { customAlphabet } from 'nanoid';

export const nanoid = customAlphabet('1234567890abcdefghijklmnopqrstuvwxyz', 6);

export function createUniqueFilename(filename) {
  const dotIndex = filename.lastIndexOf('.');
  return dotIndex !== -1
    ? filename.substring(0, dotIndex) + '-' + nanoid() + filename.substring(dotIndex)
    : filename + '-' + nanoid();
}